import { render } from "./SecondBar.vue?vue&type=template&id=a2f6f674&scoped=true"
import script from "./SecondBar.vue?vue&type=script&lang=js"
export * from "./SecondBar.vue?vue&type=script&lang=js"

import "./SecondBar.vue?vue&type=style&index=0&id=a2f6f674&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f6f674"]])

export default __exports__